import React from 'react';
import './add product.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message ,TreeSelect} from "antd";
import { UploadOutlined } from '@ant-design/icons';
const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;

class AddProduct extends React.Component {
    state = {
        name_en:'',
        name_ar:'',
        description_en:'',
        description_ar:'',
        link:'',
        price:0,
        brand:null,
        influencer:null,
        interests:[],
        occasions:[],
        brands:[],
        influencers:[],
        allOccasions:[],
        allInterests:[],
        limit:1,
        selectedFile: null,
        img: null,
        imgType:'data',
        imgName:'',
        forGender:'BOTH'
        
    };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
        this.getBrands()
        this.getInfluencers()
        this.getOccasions()
        this.getInterests()
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    /**
    * add request
    */
    add = () => {
        const {forGender,name_en,name_ar,description_ar,description_en,link,price,brand,influencer,interests,occasions,img} = this.state
        let l = message.loading('Wait..', 0.5)
        if(img == null) {
            message.error(allStrings.imgRequired, 2.5)
        }
        if(hasValue(name_en)&&hasValue(name_ar) &&hasValue(description_ar) && hasValue(description_en) 
            && img !=null && hasValue(link) && hasValue(price) && brand != null  ){
            var data = new FormData()
            data.append('name_en',name_en)
            data.append('name_ar',name_ar)
            data.append('description_en',description_en)
            data.append('description_ar',description_ar)
            data.append('link',link)
            data.append('price',price)
            data.append('brand',brand)
            data.append('forGender',forGender)
            if(influencer != null) data.append('influencer',influencer)

            data.append('interests',JSON.stringify(interests))
            data.append('occasions',JSON.stringify(occasions))
            data.append('img',img)
            console.log(Array.from(data))
            axios.post(`${BASE_END_POINT}products`,data,{
                headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization':`Bearer ${this.props.currentUser.token}`,
                'Accept-Language':this.props.isRTL?'ar':'en'
                },
            })
            .then(response=>{
            console.log("product UPDATED  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
                this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }else{
            message.error(allStrings.completeData, 2.5)
        }
    }
    /**
     * 
     * get brands
    */
    getBrands = () => {
        axios.get(`${BASE_END_POINT}brands/withoutPagenation/get`)
        .then(response=>{
          console.log(response.data)
          this.setState({brands:response.data.data})
        })
        .catch(error=>{
          console.log("ALL brands ERROR")
          console.log(error.response)
        })
    }
    /**
     * 
     * get influencers
    */
    getInfluencers = () => {
        axios.get(`${BASE_END_POINT}influencers/withoutPagenation/get`)
        .then(response=>{
            console.log(response.data)
            this.setState({influencers:response.data.data})
        })
        .catch(error=>{
            console.log("ALL influencers ERROR")
            console.log(error.response)
        })
    }
    /**
     * 
     * get occasions
    */
    getOccasions = () => {
        axios.get(`${BASE_END_POINT}occasion-suggestion/withoutPagenation/get`)
        .then(response=>{
          console.log(response.data)
          this.setState({allOccasions:response.data.data})
        })
        .catch(error=>{
          console.log("ALL occasions ERROR")
          console.log(error.response)
        })
    }
    /**
     * 
     * get interests
    */
    getInterests = () => {
        axios.get(`${BASE_END_POINT}interests/withoutPagenation/get`)
        .then(response=>{
          console.log(response.data)
          this.setState({allInterests:response.data.data})
        })
        .catch(error=>{
          console.log("ALL interests ERROR")
          console.log(error.response)
        })
    }

    /**
      * form submit Handler
    */
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.add()
    };
    /**
      * form inputs Handler
    */
    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    /**
      * upload file
    */
    fileChangedHandler = event => {
        this.setState({
            img: event.target.files[0],
            imgName: event.target.files[0].name,
            imgType:"data"
        })
    }
    /**
      * remove file
    */
    removeFile = () => {
      this.setState({
          img:null,
          imgName:'',
          imgType:"url"
      });
    }
   
  render(){
    console.log("type",this.state.type)
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('productS')) return <Redirect to='/Home' />

  return (
    <div className="App">
        <MDBContainer> 
            <MDBRow>  
                <MDBCol md="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div  style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>local_mall</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{allStrings.add}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishName}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name_en} type="text" id="form645" name="name_en" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicName}</label>
                                            <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.name_ar} type="text" id="form56" name="name_ar" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.price}</label>
                                            <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.price} type="number" id="form645" name="price" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                            <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.link} type="url" id="form645" name="link" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="form70" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicDescription}</label>
                                            <br></br>
                                            <textarea onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } 
                                            placeholder={allStrings.arabicDescription} rows="3" style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} 
                                            defaultValue={this.state.description_ar} type="text" id="form70" className="form-control" onChange={this.changeHandler} required validate name="description_ar"/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                        <div className="md-form">
                                            <label htmlFor="form70" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishDescription}</label>
                                            <br></br>
                                            <textarea onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }
                                            placeholder={allStrings.englishDescription} rows="3" style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} 
                                            defaultValue={this.state.description_en} type="text" id="form70" className="form-control" onChange={this.changeHandler} required validate name="description_en"/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="6" sm="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.interests}</label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {true}
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.interests}
                                                value={this.state.interests}
                                                showCheckedStrategy= {SHOW_PARENT}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    this.setState({interests:value});
                                                }} 
                                            
                                            >
                                                {this.state.allInterests.map(val=>(
                                                    <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                        </MDBCol>
                                        <MDBCol md="6" sm="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.occasions}</label>
                                            <TreeSelect virtual={false}
                                                showSearch={false} 
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {true}         
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.occasions}
                                                value={this.state.occasions}
                                                showCheckedStrategy= {SHOW_PARENT}
                                                onChange={(value) => {
                                                console.log(value)
                                                this.setState({occasions:value});
                                                }} 
                                            
                                            >
                                                {this.state.allOccasions.map(val=>(
                                                    <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="6" sm="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.brand}</label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.brand}
                                                value={this.state.brand}
                                                showCheckedStrategy= {SHOW_PARENT}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    this.setState({brand:value});
                                                }} 
                                            
                                            >
                                                {this.state.brands.map(val=>(
                                                    <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                        </MDBCol>
                                        <MDBCol md="6" sm="6">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.influencer}</label>
                                            <TreeSelect virtual={false}
                                                showSearch={true}
                                                disabled={this.state.actionType==="VIEW"?true:false}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.influencer}
                                                value={this.state.influencer}
                                                showCheckedStrategy= {SHOW_PARENT}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    this.setState({influencer:value});
                                                }} 
                                            
                                            >
                                                {this.state.influencers.map(val=>(
                                                    <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                                ))}
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12" sm="12">
                                            <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.forGender}</label>
                                            <TreeSelect virtual={false}
                                                showSearch={false}
                                                style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                treeCheckable = {false}
                                                treeNodeFilterProp="title"                      
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={allStrings.forGender}
                                                value={this.state.forGender}
                                                showCheckedStrategy= {SHOW_PARENT}
                                                onChange={(value) => {
                                                    console.log(value)
                                                    this.setState({forGender:value});
                                                }} 
                                            >
                                                    <TreeNode value="MALE" title={allStrings.male} key="MALE" />
                                                    <TreeNode value="FEMALE" title={allStrings.female} key="FEMALE" />
                                                    <TreeNode value="BOTH" title={allStrings.both} key="BOTH" />
                                                
                                            </TreeSelect>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2"> 
                                                <input  key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                            </div>
                                            <div className="preview">
                                            {this.state.img&&
                                            <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                <img alt="" src={URL.createObjectURL(this.state.img)}  className="previewImg2"/>
                                                
                                                <span className="imgName">{this.state.imgName}</span>
                                                <MDBIcon icon="trash" className="mr-2 removeImg2"
                                                onClick={() => this.removeFile()}  ></MDBIcon>
                                            </div>
                                            }
                                            </div>
                                            
                                        </MDBCol>
                                    </MDBRow>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                        <MDBBtn
                                        style={{background:'#117183',color:'#fff'}}
                                        rounded
                                        color="#117183"
                                        type="submit"
                                        className="btn-block z-depth-1a"
                                        >
                                        <MDBIcon icon="plus" className="mr-2" />
                                            {allStrings.add}          
                                        </MDBBtn>
                                       
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});
  
const mapDispatchToProps = {
};
  
export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(AddProduct)
);